import styled, { css } from 'styled-components';
import {
  ItemMobile,
  WrapperList,
  WrapperOriginAndDestinationMobile,
  WrapperSkeletonListMobile,
  WrapperTruckerInfoMobile,
} from '@components/ui/JourneyList/JourneyListSkeletonStyles';

export const WrapperStyledFuelGridContainer = WrapperSkeletonListMobile;
export const Wrapper = WrapperList;
export const WrapperTruckerInfo = WrapperTruckerInfoMobile;

export const WrapperOriginAndDestination = WrapperOriginAndDestinationMobile;

export const Item = ItemMobile;

export const WrapperListAllTabMobile = styled.div`
  ${({ theme }) => css`
    width: 100%;
    margin-top: ${theme.padding.km2};
    > div {
      position: relative;
    }

    > div:after {
      content: '';
      display: block;
      width: calc(100% + 48px);
      height: 1px;
      background: ${theme.color.border.neutral.default};
      position: absolute;
      bottom: 0px;
      left: -24px;
    }
    > div:last-child:after {
      content: none;
    }
  `}
`;
